// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    scroll-behavior: smooth;
}

.BC-Page__Turbo-Landing-Page {
    color: #ffffff;
    background: #190738;
    text-align: center;
    position: relative;
}

.BC-Page__Turbo-Landing-Page .Polaris-Page {
    max-width: 69rem;
    padding: 0 !important;
}

/* START: Common */
.BC-Page__Turbo-Landing-Page .shake {
    transform-origin: center;
    transform-style: preserve-3d;
}

.BC-Page__Turbo-Landing-Page .shake-card-left {
    animation: shake-card-left 3s infinite;
    transform-origin: center;
    transform-style: preserve-3d;
}

.BC-Page__Turbo-Landing-Page .shake-card-right {
    animation: shake-card-right 4s infinite;
    transform-origin: center;
    transform-style: preserve-3d;
}

.BC-Page__Turbo-Landing-Page button {
    border: 0;
    border-radius: 4px;
    padding: 10px 24px 12px 24px;
    justify-content: space-between;
    text-transform: uppercase;
    color: white;
    font-weight: 500;
    font-size: 16px;
    cursor: pointer;
}

.BC-Page__Turbo-Landing-Page button.primary {
    background: linear-gradient(91.21deg, #C830E1 1.04%, #FE4A25 131.05%);
    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);
    min-width: 142px;
    min-height: 46px;
}

.BC-Page__Turbo-Landing-Page button.primary:hover {
    background: linear-gradient(91.21deg, #920DA7 1.04%, #CE2907 131.05%);
    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);

}

.BC-Page__Turbo-Landing-Page button.normal {
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.05);
    min-width: 140px;
    min-height: 46px;
}

.BC-Page__Turbo-Landing-Page button.normal:hover {
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset;
    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);
    background: rgba(255, 255, 255, 0.15);
}

.BC-Page__Turbo-Landing-Page .action {
    display: flex;
    gap: 20px;
}

.BC-Page__Turbo-Landing-Page .flex {
    display: flex;
    width: 100%;
}

.BC-Page__Turbo-Landing-Page section {
    padding: 50px 0;
    background-repeat: no-repeat !important;
    min-height: 600px;
}

.BC-Page__Turbo-Landing-Page section .container {
    max-width: 1104px;
    padding: 0;
    width: 100%;
    margin: 0 auto;
    position: relative;
}

.parallax,
.parallax-x-l,
.parallax-x-r,
.parallax-y {
    opacity: 0;
    transition: opacity 0.3s ease-out, transform 0.3s ease-out;
}

.parallax {
    transform: translateY(20px);
}

.parallax.visible {
    opacity: 1;
    transform: translateY(0);
}

.parallax-y {
    transform: translateY(50px);
}

.parallax-y.visible {
    opacity: 1;
    transform: translateY(0);
}

.parallax-x-r {
    transform: translateX(-60px);
}

.parallax-x-r.visible {
    opacity: 1;
    transform: translateX(0);
}

.parallax-x-l {
    transform: translateX(50px);
}

.parallax-x-l.visible {
    opacity: 1;
    transform: translateX(0);
}

.logo-container {
    position: relative;
}

.logo-container .logo {
    position: relative;
    z-index: 2;
    width: 400px;
}

.logo-container .logo-effect {
    position: absolute;
}

.logo-main {
    width: 50%;
    height: auto;
    animation: fadeIn1 3s forwards, rotate3D 4s infinite linear;
    animation-delay: 0s, 3s;
    opacity: 0;
}

.logo-container .logo-effect-1 {
    top: 40%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    animation: fadeIn3 5s forwards, blink 3s infinite;
    animation-delay: 0s, 5s;
    opacity: 0;
}

.logo-container .logo-effect-2 {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    animation: fadeIn3 5s forwards, blink 2s infinite;
    animation-delay: 0s, 5s;
    opacity: 0;
}

.logo-container .logo-effect-3 {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    animation: fadeIn3 5s forwards, blink 1s infinite;
    animation-delay: 0s, 5s;
    opacity: 0;

}

.fade-in-1 {
    animation: fadeIn1 3s forwards;
    opacity: 0;
}

.fade-in-2 {
    animation: fadeIn2 5s forwards;
    opacity: 0;
}

.fade-in-3 {
    animation: fadeIn3 5s forwards;
    opacity: 0;
}

section.intro,
section.what-is,
section.why,
section.faq {
    animation: moveBackgroundRandom1 8s linear infinite;
}

section.logo,
section.how-fast,
section.steps {
    animation: moveBackgroundRandom2 10s linear infinite;
}

section.contact {
    animation: moveBackgroundRandom3 5s linear infinite;
}

/* START: Keyframes */
@keyframes fadeIn1 {
    0% {
        opacity: 0;
        bottom: -100%;
        left: -50%;
        transform: scale(0.1);
    }

    30% {
        opacity: 0;
    }

    100% {
        opacity: 1;
        bottom: 0;
        left: 0;
        transform: scale(1);
    }
}

@keyframes fadeIn2 {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeIn3 {
    0% {
        opacity: 0;
    }

    70% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}


@keyframes blink {

    0%,
    100% {
        opacity: 0.6;
    }

    50% {
        opacity: 1;
    }
}

@keyframes moveBackgroundRandom1 {

    0%,
    100% {
        background-position: 0% 0%;
    }

    25% {
        background-position: 20% 80%;
    }

    50% {
        background-position: 50% 10%;
    }

    75% {
        background-position: 90% 0%;
    }
}

@keyframes moveBackgroundRandom2 {

    0%,
    100% {
        background-position: 0% 0%;
    }

    25% {
        background-position: 20% 80%;
    }

    50% {
        background-position: 50% 10%;
    }

    75% {
        background-position: 90% 0%;
    }
}

@keyframes moveBackgroundRandom3 {

    0%,
    100% {
        background-position: 0% 0%;
    }

    50% {
        background-position: 100% 100%;
    }
}

@keyframes rotate3D {
    0% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    }

    50% {
        transform: rotateX(10deg) rotateY(-20deg) rotateZ(1deg)
    }

    100% {
        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)
    }
}

@keyframes rotation {
    0% {
        --gradient-angle: 0deg;
    }

    70% {
        --gradient-angle: 240deg;
    }

    100% {
        --gradient-angle: 360deg;
    }
}

@keyframes rotation90 {
    0% {
        --gradient-angle: 270deg;
    }

    100% {
        --gradient-angle: 360deg;
    }
}

@keyframes scale {

    0% {
        transform: scale(1);
    }

    100% {
        transform: perspective(500px) rotateX(25deg) rotateY(30deg);
        transform: scale(1.2);
    }
}

@keyframes shake-and-zoom {

    0%,
    100% {
        transform: perspective(500px) rotateX(0deg) rotateY(0deg);
        transform: scale(1);
    }

    45% {
        transform: scale(1.2);
    }

    50% {
        transform: perspective(500px) rotateX(25deg) rotateY(30deg);
        transform: scale(1.5);
    }

    55% {
        transform: scale(1.2);
    }
}

@keyframes shake-card-left {
    0% {
        transform: perspective(500px) rotateX(0deg) rotateY(0deg);
    }

    33% {
        transform: perspective(500px) rotateX(0deg) rotateY(-10deg);
    }

    66% {
        transform: perspective(500px) rotateX(0deg) rotateY(-20deg);
    }

    100% {
        transform: perspective(500px) rotateX(0deg) rotateY(0deg);
    }
}

@keyframes shake-card-right {
    0% {
        transform: perspective(500px) rotateX(0deg) rotateY(0deg);
    }

    50% {
        transform: perspective(500px) rotateX(0deg) rotateY(20deg);
    }
}

@property --gradient-angle {
    syntax: "<angle>";
    initial-value: 0deg;
    inherits: false;
}

/* END: Keyframes */

.BC-Page__Turbo-Landing-Page section .blur-bg {
    display: none;
}

.BC-Page__Turbo-Landing-Page section .blur-bg#blur-bg1 {
    position: absolute;
    display: block;
    left: 50%;
    top: 0;
}

@media (max-width: 1120px) {
    .BC-Page__Turbo-Landing-Page section {
        padding: 20px;
    }
}

.BC-Page__Turbo-Landing-Page section img {
    max-width: 100%;
}

.BC-Page__Turbo-Landing-Page .left,
.BC-Page__Turbo-Landing-Page .right {
    width: 50%;
}

.BC-Page__Turbo-Landing-Page .title {
    font-size: 42px;
    font-weight: 600;
    line-height: 44px;
}

.BC-Page__Turbo-Landing-Page .description {
    font-size: 16px;
    font-weight: 400;
}

.BC-Page__Turbo-Landing-Page section .head {
    display: flex;
}

.BC-Page__Turbo-Landing-Page section .head .left {
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;
    text-align: left;
}

.BC-Page__Turbo-Landing-Page section .head .right {
    display: flex;
    justify-content: flex-end;
}

/* END: Common */

/* START: Custom section */
.BC-Page__Turbo-Landing-Page section.intro {
    padding-bottom: 0;
    min-height: 900px;
}

.BC-Page__Turbo-Landing-Page section.intro .wrapper {
    max-width: 662px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;
    margin: 0 auto;
    margin-top: 40px;
}

.BC-Page__Turbo-Landing-Page section.intro .sub-title {
    font-weight: 400;
    font-size: 16px;
}

.BC-Page__Turbo-Landing-Page section.intro .action {
    margin: 0 auto;
}

.BC-Page__Turbo-Landing-Page section.what-is .right {
    justify-content: flex-start;
}

.BC-Page__Turbo-Landing-Page section.what-is .right .what-image {
    max-width: calc(100% - 20px);
}

.BC-Page__Turbo-Landing-Page section.what-is .right .what-image svg {
    max-width: 100%;
    height: auto;
}

.BC-Page__Turbo-Landing-Page section.how-fast {
    padding-top: 100px;
}

.BC-Page__Turbo-Landing-Page section.how-fast .container {
    display: flex;
    flex-direction: column;
    gap: 80px;
}

.BC-Page__Turbo-Landing-Page section.how-fast .block-compare {
    background: linear-gradient(180deg, rgba(255, 94, 190, 0.02) 0%, rgba(200, 48, 225, 0.12) 100%);
    padding: 32px 24px 40px 24px;
    border-radius: 12px;
}

.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .title {
    font-weight: 600;
    font-size: 14px;
    text-align: left;
}

.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .head,
.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .versions,
.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .versions div {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.BC-Page__Turbo-Landing-Page section.how-fast .note {
    text-align: right;
    font-style: italic;
    color: rgba(244, 245, 246, 1);
    opacity: 0.7;
}

.BC-Page__Turbo-Landing-Page section.how-fast .right {
    justify-content: center;
}

.BC-Page__Turbo-Landing-Page section.how-fast .how-fast-image {
    width: 424px;
    max-width: 424px;
    height: 186px;
    position: relative;
}

.BC-Page__Turbo-Landing-Page section.how-fast #card1,
.BC-Page__Turbo-Landing-Page section.how-fast #card2,
.BC-Page__Turbo-Landing-Page section.how-fast #star1,
.BC-Page__Turbo-Landing-Page section.how-fast #star2,
.BC-Page__Turbo-Landing-Page section.how-fast #how-fast-effect {
    position: absolute;
}

.BC-Page__Turbo-Landing-Page section.how-fast #card1 {
    left: -50px;
    top: -50px;
}

.BC-Page__Turbo-Landing-Page section.how-fast #card2 {
    right: -35px;
    bottom: -50px;
}

.BC-Page__Turbo-Landing-Page section.how-fast #star1 {
    left: 50%;
    top: 0;
    animation: shake-and-zoom 3s infinite;
}

.BC-Page__Turbo-Landing-Page section.how-fast #star2 {
    right: 70%;
    bottom: 0;
    animation: shake-and-zoom 2s infinite;
}

@media (max-width: 480px) {

    .BC-Page__Turbo-Landing-Page section.how-fast #card1 {
        left: -20px;
        top: -60px;
    }

    .BC-Page__Turbo-Landing-Page section.how-fast #card2 {
        right: -15px;
        bottom: -100px;
    }

    .BC-Page__Turbo-Landing-Page section.how-fast #star1 {
        left: 60%;
        top: 30px;
    }

    .BC-Page__Turbo-Landing-Page section.how-fast #star2 {
        right: 80%;
        bottom: 0;
    }
}

.BC-Page__Turbo-Landing-Page section.how-fast #how-fast-effect {
    right: 25%;
    bottom: -40px;
    animation: rotate3D 2s infinite;
    transform: scale(1);
    opacity: 0.5;
}

.BC-Page__Turbo-Landing-Page section.why .container {
    display: flex;
    flex-direction: column;
    gap: 50px;
}

.BC-Page__Turbo-Landing-Page section.why .head {
    display: flex;
    flex-direction: column;
    gap: 25px;
    max-width: 610px;
    margin: 0 auto;
    padding: 10px;
}

.BC-Page__Turbo-Landing-Page section.why .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    max-width: 1100px;
    margin: 0 auto;
}

.BC-Page__Turbo-Landing-Page section.why .list .item-action span:hover {
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 4px;
}

.BC-Page__Turbo-Landing-Page section.steps {
    padding-top: 100px;
}

.BC-Page__Turbo-Landing-Page section.steps .head .right iframe {
    max-width: 100%;
}

.BC-Page__Turbo-Landing-Page section.steps .head .left {
    position: relative;
    width: calc(100% - 656px);
}

.BC-Page__Turbo-Landing-Page section.steps .head .right {
    width: 656px;
    position: relative;
}

.BC-Page__Turbo-Landing-Page section.steps .head .right .play {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    max-width: 656px;
    height: 100%;
    transform: translate(-50%, -50%);
    display: flex;
    justify-content: center;
    align-items: center;
}

.BC-Page__Turbo-Landing-Page section.steps .head .right .play img:hover {
    cursor: pointer;
    width: 90px;
    height: 90px;
}

.BC-Page__Turbo-Landing-Page section.steps .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 50px;
}

@media (max-width: 1024px) {
    .BC-Page__Turbo-Landing-Page section.why .list {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 1020px) {
    .BC-Page__Turbo-Landing-Page section.steps .head {
        flex-direction: column;
        gap: 20px;
    }

    .BC-Page__Turbo-Landing-Page section.steps .head .left,
    .BC-Page__Turbo-Landing-Page section.steps .head .right {
        width: 100%;
    }

    .BC-Page__Turbo-Landing-Page section.steps .head .right {
        justify-content: center;
    }

    .BC-Page__Turbo-Landing-Page section.contact {
        min-height: 300px;
    }

}

@media (max-width: 760px) {
    .BC-Page__Turbo-Landing-Page section.why .list {
        grid-template-columns: repeat(1, 1fr);
    }

}

@media (max-width: 760px) {
    .BC-Page__Turbo-Landing-Page .head {
        flex-direction: column;
        gap: 25px;
    }

    .BC-Page__Turbo-Landing-Page .head .left,
    .BC-Page__Turbo-Landing-Page .head .right {
        width: 100%;
    }

    .BC-Page__Turbo-Landing-Page section .head .right {
        justify-content: center;
    }

    .BC-Page__Turbo-Landing-Page section.steps .list {
        grid-template-columns: repeat(1, 1fr);
    }

}

.BC-Page__Turbo-Landing-Page section.steps .list .step {
    position: relative;
    padding-left: 50px;
}

.BC-Page__Turbo-Landing-Page section.steps .list .step .icon {
    position: absolute;
    left: -40px;
    top: -34px;
}

.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content {
    text-align: left;
}

.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-title {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 10px;
}

.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-label {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 10px;
}

.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-description {
    font-weight: 400;
    font-size: 14px;
    display: inline-grid;
    line-height: 20px;
    /* display: flex;
    flex-wrap: wrap;
    align-items: center; */
}

.BC-Page__Turbo-Landing-Page section.faq .head {
    display: flex;
    flex-direction: column;
    gap: 25px;
    padding: 30px 0;
    max-width: 768px;
    margin: 0 auto;
}

.BC-Page__Turbo-Landing-Page section.faq .list {
    max-width: 768px;
    margin: 0 auto;
}

.BC-Page__Turbo-Landing-Page .Faq-list a {
    text-decoration: none;
}

.BC-Page__Turbo-Landing-Page .Faq-list a * {
    text-decoration: underline;
    text-decoration-thickness: 1px;
    text-underline-offset: 4px;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item:last-child {
    border-bottom: 0;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .activator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    font-weight: 600;
    text-align: left;
    font-size: 20px;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .question {
    width: calc(100% - 30px);
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .icon {
    width: 30px;
    text-align: right;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .activator:hover {
    cursor: pointer;
    color: rgba(244, 245, 246, 1);
    opacity: 0.7;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .content {
    padding: 0;
    padding-bottom: 40px;
    text-align: left;
    padding-right: 40px;
    line-height: 24px;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .content a {
    color: white;
}

.BC-Page__Turbo-Landing-Page section.faq .faq-item .content>div {
    display: flex;
    gap: 20px;
    flex-direction: column;
}

.BC-Page__Turbo-Landing-Page section.banner {
    padding-bottom: 100px;
    min-height: 300px;
}

.BC-Page__Turbo-Landing-Page section.banner .wrapper {
    width: 100%;
    margin: 0 auto;
    border-radius: 16px;
    display: flex;
    position: relative;
}

.BC-Page__Turbo-Landing-Page section.banner .wrapper .banner-bg {
    width: 100%;
}

.BC-Page__Turbo-Landing-Page section.banner .wrapper .content {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 20px;
    padding-left: 40px;
}

.BC-Page__Turbo-Landing-Page section.banner .wrapper .content .title {
    max-width: 70%;
}

.BC-Page__Turbo-Landing-Page .footer {
    min-height: unset;
    height: 0;
    padding: 0;
}

.BC-Page__Turbo-Landing-Page .footer .back {
    position: fixed;
    right: 30px;
    top: 30px;
    border-radius: 50%;
    background: linear-gradient(91.21deg, #C830E1 1.04%, #FE4A25 131.05%);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);
    width: 48px;
    height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.BC-Page__Turbo-Landing-Page .footer .back:hover {
    animation: scale 0.5s forwards;
}

.BC-Page__Turbo-Landing-Page .footer .back.shown-bubble {
    right: 20px;
    bottom: 90px;
}

.BC-Page__Turbo-Landing-Page .footer .back:hover {
    background: linear-gradient(91.21deg, #920DA7 1.04%, #CE2907 131.05%);
    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);
}

@media (max-width: 768px) {
    .BC-Page__Turbo-Landing-Page section.banner {
        padding-bottom: 100px;
        min-height: unset;
    }

    .BC-Page__Turbo-Landing-Page section.banner .wrapper .content .action {
        position: absolute;
        bottom: -60px;
        width: 100%;
        left: 0;
    }
}

/* END: Custom section */

.darksoul-gradient-card1 {
    display: flex;
    height: 296px;
    background: linear-gradient(var(--gradient-angle), #190738, #190738, #C830E1, rgb(104, 3, 255), #190738, #190738);
    border-radius: 16px;
    animation: rotation90 10s linear 0s infinite normal forwards;
    backdrop-filter: blur(50px);
}

.darksoul-content-card {
    margin: auto;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    background-color: #190738;
    border-radius: 16px;
    transition: all 2s;
    backdrop-filter: blur(16px);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
}

.darksoul-content-card .item-title {
    font-size: 20px;
    font-weight: 600;
}

.darksoul-content-card .item-description {
    font-size: 14px;
    font-weight: 400;
    padding: 0 15px;
    text-align: center;
    height: 50px;
}

.darksoul-content-card .item-action {
    display: flex;
    cursor: pointer;
    gap: 6px;
    width: 100%;
    justify-content: center;
    align-items: center;
}

@media only screen and (max-width: 700px) {
    body {
        margin: 0;
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: rgb(13, 13, 13);
    }

    .darksoul-gradient-card1 {
        margin: auto;
        width: 80%;
        min-height: 200px;
        margin-top: 10px;
        margin-bottom: 10px;
    }

}

.Polaris-Modal-Dialog__Modal:has(.video-modal) {
    max-width: 912px;
    border-radius: 0;
}

.Polaris-Modal-Dialog__Modal:has(.video-modal) .video-modal {
    width: 100%;
    position: relative;
}

.Polaris-Modal-Dialog__Modal:has(.video-modal) .video-modal::before {
    content: "";
    display: block;
    padding-top: 50%;
}

.Polaris-Modal-Dialog__Modal:has(.video-modal) .inner-content {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 20px;
}

.Polaris-Modal-Dialog__Modal:has(.video-modal) .close {
    position: absolute;
    right: 0;
    border-radius: 50%;
    top: 0;
    z-index: 99;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.Polaris-Modal-Dialog__Modal:has(.video-modal) .close:hover {
    background: rgba(0, 0, 0, 0.318);
    cursor: pointer;
    border: 1px solid white;
}

@media only screen and (max-width: 700px) {
    .Polaris-Modal-Dialog__Modal:has(.video-modal) {
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
    }
}

.BC-Page__Turbo-Landing-Page .navigate {
    position: fixed;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.BC-Page__Turbo-Landing-Page .navigate .item {
    padding: 4px;
    border-radius: 50%;
    position: relative;
}

.BC-Page__Turbo-Landing-Page .navigate .item .circle {
    display: block;
    width: 10px;
    height: 10px;
    background: #FFFFFF33;
    border-radius: 50%;
}

.BC-Page__Turbo-Landing-Page .navigate .item.active .circle {
    background: #F442C8;
}

.BC-Page__Turbo-Landing-Page .navigate .item:hover {
    cursor: pointer;
}

.BC-Page__Turbo-Landing-Page .navigate .item:hover .circle {
    background: #A531DC;
}

.BC-Page__Turbo-Landing-Page .navigate .navigate-tooltip::after {
    content: var(--tooltip-content);
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    background: #F82C9326;
    color: #fff;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    width: auto;
    white-space: nowrap;
    padding: 4px 8px;
}

.BC-Page__Turbo-Landing-Page .navigate .navigate-tooltip:hover::after {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/styles/landing-page/turbo.css"],"names":[],"mappings":"AAAA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,sCAAsC;IACtC,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,4BAA4B;IAC5B,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qEAAqE;IACrE,0DAA0D;IAC1D,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qEAAqE;IACrE,0DAA0D;;AAE9D;;AAEA;IACI,0CAA0C;IAC1C,qDAAqD;IACrD,+CAA+C;IAC/C,qCAAqC;IACrC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,qDAAqD;IACrD,+CAA+C;IAC/C,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,eAAe;IACf,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;;IAII,UAAU;IACV,0DAA0D;AAC9D;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,2DAA2D;IAC3D,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,iDAAiD;IACjD,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,iDAAiD;IACjD,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,iDAAiD;IACjD,uBAAuB;IACvB,UAAU;;AAEd;;AAEA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,UAAU;AACd;;AAEA;;;;IAII,mDAAmD;AACvD;;AAEA;;;IAGI,oDAAoD;AACxD;;AAEA;IACI,mDAAmD;AACvD;;AAEA,qBAAqB;AACrB;IACI;QACI,UAAU;QACV,aAAa;QACb,UAAU;QACV,qBAAqB;IACzB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QACV,SAAS;QACT,OAAO;QACP,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;;AAGA;;IAEI;;QAEI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;;IAEI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,2DAA2D;QAC3D,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;;QAEI,yDAAyD;QACzD,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,2DAA2D;QAC3D,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,yDAAyD;IAC7D;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,yDAAyD;IAC7D;AACJ;;AAEA;IACI;QACI,yDAAyD;IAC7D;;IAEA;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,mBAAmB;;AAEnB;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,MAAM;AACV;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA,gBAAgB;;AAEhB,0BAA0B;AAC1B;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,+FAA+F;IAC/F,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;;;;;IAKI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,MAAM;IACN,qCAAqC;AACzC;;AAEA;IACI,UAAU;IACV,SAAS;IACT,qCAAqC;AACzC;;AAEA;;IAEI;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,SAAS;QACT,SAAS;IACb;;IAEA;QACI,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;AAEJ;;AAEA;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qCAAqC;IACzC;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB;;0BAEsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,qEAAqE;IACrE,+CAA+C;IAC/C,8CAA8C;IAC9C,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qEAAqE;IACrE,0DAA0D;AAC9D;;AAEA;IACI;QACI,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,WAAW;QACX,OAAO;IACX;AACJ;;AAEA,wBAAwB;;AAExB;IACI,aAAa;IACb,aAAa;IACb,iHAAiH;IACjH,mBAAmB;IACnB,4DAA4D;IAC5D,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;;IAE3B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI;QACI,SAAS;QACT,WAAW;QACX,aAAa;QACb,aAAa;QACb,sBAAsB;QACtB,iCAAiC;IACrC;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;;AAEJ;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI;QACI,QAAQ;QACR,2BAA2B;QAC3B,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd","sourcesContent":["html,\nbody {\n    scroll-behavior: smooth;\n}\n\n.BC-Page__Turbo-Landing-Page {\n    color: #ffffff;\n    background: #190738;\n    text-align: center;\n    position: relative;\n}\n\n.BC-Page__Turbo-Landing-Page .Polaris-Page {\n    max-width: 69rem;\n    padding: 0 !important;\n}\n\n/* START: Common */\n.BC-Page__Turbo-Landing-Page .shake {\n    transform-origin: center;\n    transform-style: preserve-3d;\n}\n\n.BC-Page__Turbo-Landing-Page .shake-card-left {\n    animation: shake-card-left 3s infinite;\n    transform-origin: center;\n    transform-style: preserve-3d;\n}\n\n.BC-Page__Turbo-Landing-Page .shake-card-right {\n    animation: shake-card-right 4s infinite;\n    transform-origin: center;\n    transform-style: preserve-3d;\n}\n\n.BC-Page__Turbo-Landing-Page button {\n    border: 0;\n    border-radius: 4px;\n    padding: 10px 24px 12px 24px;\n    justify-content: space-between;\n    text-transform: uppercase;\n    color: white;\n    font-weight: 500;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.BC-Page__Turbo-Landing-Page button.primary {\n    background: linear-gradient(91.21deg, #C830E1 1.04%, #FE4A25 131.05%);\n    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);\n    min-width: 142px;\n    min-height: 46px;\n}\n\n.BC-Page__Turbo-Landing-Page button.primary:hover {\n    background: linear-gradient(91.21deg, #920DA7 1.04%, #CE2907 131.05%);\n    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);\n\n}\n\n.BC-Page__Turbo-Landing-Page button.normal {\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset;\n    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.05);\n    min-width: 140px;\n    min-height: 46px;\n}\n\n.BC-Page__Turbo-Landing-Page button.normal:hover {\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.2) inset;\n    box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08);\n    background: rgba(255, 255, 255, 0.15);\n}\n\n.BC-Page__Turbo-Landing-Page .action {\n    display: flex;\n    gap: 20px;\n}\n\n.BC-Page__Turbo-Landing-Page .flex {\n    display: flex;\n    width: 100%;\n}\n\n.BC-Page__Turbo-Landing-Page section {\n    padding: 50px 0;\n    background-repeat: no-repeat !important;\n    min-height: 600px;\n}\n\n.BC-Page__Turbo-Landing-Page section .container {\n    max-width: 1104px;\n    padding: 0;\n    width: 100%;\n    margin: 0 auto;\n    position: relative;\n}\n\n.parallax,\n.parallax-x-l,\n.parallax-x-r,\n.parallax-y {\n    opacity: 0;\n    transition: opacity 0.3s ease-out, transform 0.3s ease-out;\n}\n\n.parallax {\n    transform: translateY(20px);\n}\n\n.parallax.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.parallax-y {\n    transform: translateY(50px);\n}\n\n.parallax-y.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.parallax-x-r {\n    transform: translateX(-60px);\n}\n\n.parallax-x-r.visible {\n    opacity: 1;\n    transform: translateX(0);\n}\n\n.parallax-x-l {\n    transform: translateX(50px);\n}\n\n.parallax-x-l.visible {\n    opacity: 1;\n    transform: translateX(0);\n}\n\n.logo-container {\n    position: relative;\n}\n\n.logo-container .logo {\n    position: relative;\n    z-index: 2;\n    width: 400px;\n}\n\n.logo-container .logo-effect {\n    position: absolute;\n}\n\n.logo-main {\n    width: 50%;\n    height: auto;\n    animation: fadeIn1 3s forwards, rotate3D 4s infinite linear;\n    animation-delay: 0s, 3s;\n    opacity: 0;\n}\n\n.logo-container .logo-effect-1 {\n    top: 40%;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 3;\n    animation: fadeIn3 5s forwards, blink 3s infinite;\n    animation-delay: 0s, 5s;\n    opacity: 0;\n}\n\n.logo-container .logo-effect-2 {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 3;\n    animation: fadeIn3 5s forwards, blink 2s infinite;\n    animation-delay: 0s, 5s;\n    opacity: 0;\n}\n\n.logo-container .logo-effect-3 {\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1;\n    animation: fadeIn3 5s forwards, blink 1s infinite;\n    animation-delay: 0s, 5s;\n    opacity: 0;\n\n}\n\n.fade-in-1 {\n    animation: fadeIn1 3s forwards;\n    opacity: 0;\n}\n\n.fade-in-2 {\n    animation: fadeIn2 5s forwards;\n    opacity: 0;\n}\n\n.fade-in-3 {\n    animation: fadeIn3 5s forwards;\n    opacity: 0;\n}\n\nsection.intro,\nsection.what-is,\nsection.why,\nsection.faq {\n    animation: moveBackgroundRandom1 8s linear infinite;\n}\n\nsection.logo,\nsection.how-fast,\nsection.steps {\n    animation: moveBackgroundRandom2 10s linear infinite;\n}\n\nsection.contact {\n    animation: moveBackgroundRandom3 5s linear infinite;\n}\n\n/* START: Keyframes */\n@keyframes fadeIn1 {\n    0% {\n        opacity: 0;\n        bottom: -100%;\n        left: -50%;\n        transform: scale(0.1);\n    }\n\n    30% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n        bottom: 0;\n        left: 0;\n        transform: scale(1);\n    }\n}\n\n@keyframes fadeIn2 {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeIn3 {\n    0% {\n        opacity: 0;\n    }\n\n    70% {\n        opacity: 0;\n    }\n\n    100% {\n        opacity: 1;\n    }\n}\n\n\n@keyframes blink {\n\n    0%,\n    100% {\n        opacity: 0.6;\n    }\n\n    50% {\n        opacity: 1;\n    }\n}\n\n@keyframes moveBackgroundRandom1 {\n\n    0%,\n    100% {\n        background-position: 0% 0%;\n    }\n\n    25% {\n        background-position: 20% 80%;\n    }\n\n    50% {\n        background-position: 50% 10%;\n    }\n\n    75% {\n        background-position: 90% 0%;\n    }\n}\n\n@keyframes moveBackgroundRandom2 {\n\n    0%,\n    100% {\n        background-position: 0% 0%;\n    }\n\n    25% {\n        background-position: 20% 80%;\n    }\n\n    50% {\n        background-position: 50% 10%;\n    }\n\n    75% {\n        background-position: 90% 0%;\n    }\n}\n\n@keyframes moveBackgroundRandom3 {\n\n    0%,\n    100% {\n        background-position: 0% 0%;\n    }\n\n    50% {\n        background-position: 100% 100%;\n    }\n}\n\n@keyframes rotate3D {\n    0% {\n        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)\n    }\n\n    50% {\n        transform: rotateX(10deg) rotateY(-20deg) rotateZ(1deg)\n    }\n\n    100% {\n        transform: rotateX(0deg) rotateY(0deg) rotateZ(0deg)\n    }\n}\n\n@keyframes rotation {\n    0% {\n        --gradient-angle: 0deg;\n    }\n\n    70% {\n        --gradient-angle: 240deg;\n    }\n\n    100% {\n        --gradient-angle: 360deg;\n    }\n}\n\n@keyframes rotation90 {\n    0% {\n        --gradient-angle: 270deg;\n    }\n\n    100% {\n        --gradient-angle: 360deg;\n    }\n}\n\n@keyframes scale {\n\n    0% {\n        transform: scale(1);\n    }\n\n    100% {\n        transform: perspective(500px) rotateX(25deg) rotateY(30deg);\n        transform: scale(1.2);\n    }\n}\n\n@keyframes shake-and-zoom {\n\n    0%,\n    100% {\n        transform: perspective(500px) rotateX(0deg) rotateY(0deg);\n        transform: scale(1);\n    }\n\n    45% {\n        transform: scale(1.2);\n    }\n\n    50% {\n        transform: perspective(500px) rotateX(25deg) rotateY(30deg);\n        transform: scale(1.5);\n    }\n\n    55% {\n        transform: scale(1.2);\n    }\n}\n\n@keyframes shake-card-left {\n    0% {\n        transform: perspective(500px) rotateX(0deg) rotateY(0deg);\n    }\n\n    33% {\n        transform: perspective(500px) rotateX(0deg) rotateY(-10deg);\n    }\n\n    66% {\n        transform: perspective(500px) rotateX(0deg) rotateY(-20deg);\n    }\n\n    100% {\n        transform: perspective(500px) rotateX(0deg) rotateY(0deg);\n    }\n}\n\n@keyframes shake-card-right {\n    0% {\n        transform: perspective(500px) rotateX(0deg) rotateY(0deg);\n    }\n\n    50% {\n        transform: perspective(500px) rotateX(0deg) rotateY(20deg);\n    }\n}\n\n@property --gradient-angle {\n    syntax: \"<angle>\";\n    initial-value: 0deg;\n    inherits: false;\n}\n\n/* END: Keyframes */\n\n.BC-Page__Turbo-Landing-Page section .blur-bg {\n    display: none;\n}\n\n.BC-Page__Turbo-Landing-Page section .blur-bg#blur-bg1 {\n    position: absolute;\n    display: block;\n    left: 50%;\n    top: 0;\n}\n\n@media (max-width: 1120px) {\n    .BC-Page__Turbo-Landing-Page section {\n        padding: 20px;\n    }\n}\n\n.BC-Page__Turbo-Landing-Page section img {\n    max-width: 100%;\n}\n\n.BC-Page__Turbo-Landing-Page .left,\n.BC-Page__Turbo-Landing-Page .right {\n    width: 50%;\n}\n\n.BC-Page__Turbo-Landing-Page .title {\n    font-size: 42px;\n    font-weight: 600;\n    line-height: 44px;\n}\n\n.BC-Page__Turbo-Landing-Page .description {\n    font-size: 16px;\n    font-weight: 400;\n}\n\n.BC-Page__Turbo-Landing-Page section .head {\n    display: flex;\n}\n\n.BC-Page__Turbo-Landing-Page section .head .left {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    justify-content: center;\n    text-align: left;\n}\n\n.BC-Page__Turbo-Landing-Page section .head .right {\n    display: flex;\n    justify-content: flex-end;\n}\n\n/* END: Common */\n\n/* START: Custom section */\n.BC-Page__Turbo-Landing-Page section.intro {\n    padding-bottom: 0;\n    min-height: 900px;\n}\n\n.BC-Page__Turbo-Landing-Page section.intro .wrapper {\n    max-width: 662px;\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    justify-content: center;\n    margin: 0 auto;\n    margin-top: 40px;\n}\n\n.BC-Page__Turbo-Landing-Page section.intro .sub-title {\n    font-weight: 400;\n    font-size: 16px;\n}\n\n.BC-Page__Turbo-Landing-Page section.intro .action {\n    margin: 0 auto;\n}\n\n.BC-Page__Turbo-Landing-Page section.what-is .right {\n    justify-content: flex-start;\n}\n\n.BC-Page__Turbo-Landing-Page section.what-is .right .what-image {\n    max-width: calc(100% - 20px);\n}\n\n.BC-Page__Turbo-Landing-Page section.what-is .right .what-image svg {\n    max-width: 100%;\n    height: auto;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast {\n    padding-top: 100px;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .container {\n    display: flex;\n    flex-direction: column;\n    gap: 80px;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .block-compare {\n    background: linear-gradient(180deg, rgba(255, 94, 190, 0.02) 0%, rgba(200, 48, 225, 0.12) 100%);\n    padding: 32px 24px 40px 24px;\n    border-radius: 12px;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .title {\n    font-weight: 600;\n    font-size: 14px;\n    text-align: left;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .head,\n.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .versions,\n.BC-Page__Turbo-Landing-Page section.how-fast .block-compare .versions div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .note {\n    text-align: right;\n    font-style: italic;\n    color: rgba(244, 245, 246, 1);\n    opacity: 0.7;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .right {\n    justify-content: center;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast .how-fast-image {\n    width: 424px;\n    max-width: 424px;\n    height: 186px;\n    position: relative;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #card1,\n.BC-Page__Turbo-Landing-Page section.how-fast #card2,\n.BC-Page__Turbo-Landing-Page section.how-fast #star1,\n.BC-Page__Turbo-Landing-Page section.how-fast #star2,\n.BC-Page__Turbo-Landing-Page section.how-fast #how-fast-effect {\n    position: absolute;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #card1 {\n    left: -50px;\n    top: -50px;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #card2 {\n    right: -35px;\n    bottom: -50px;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #star1 {\n    left: 50%;\n    top: 0;\n    animation: shake-and-zoom 3s infinite;\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #star2 {\n    right: 70%;\n    bottom: 0;\n    animation: shake-and-zoom 2s infinite;\n}\n\n@media (max-width: 480px) {\n\n    .BC-Page__Turbo-Landing-Page section.how-fast #card1 {\n        left: -20px;\n        top: -60px;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.how-fast #card2 {\n        right: -15px;\n        bottom: -100px;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.how-fast #star1 {\n        left: 60%;\n        top: 30px;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.how-fast #star2 {\n        right: 80%;\n        bottom: 0;\n    }\n}\n\n.BC-Page__Turbo-Landing-Page section.how-fast #how-fast-effect {\n    right: 25%;\n    bottom: -40px;\n    animation: rotate3D 2s infinite;\n    transform: scale(1);\n    opacity: 0.5;\n}\n\n.BC-Page__Turbo-Landing-Page section.why .container {\n    display: flex;\n    flex-direction: column;\n    gap: 50px;\n}\n\n.BC-Page__Turbo-Landing-Page section.why .head {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    max-width: 610px;\n    margin: 0 auto;\n    padding: 10px;\n}\n\n.BC-Page__Turbo-Landing-Page section.why .list {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px;\n    max-width: 1100px;\n    margin: 0 auto;\n}\n\n.BC-Page__Turbo-Landing-Page section.why .list .item-action span:hover {\n    text-decoration: underline;\n    text-decoration-thickness: 1px;\n    text-underline-offset: 4px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps {\n    padding-top: 100px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .head .right iframe {\n    max-width: 100%;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .head .left {\n    position: relative;\n    width: calc(100% - 656px);\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .head .right {\n    width: 656px;\n    position: relative;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .head .right .play {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 100%;\n    max-width: 656px;\n    height: 100%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .head .right .play img:hover {\n    cursor: pointer;\n    width: 90px;\n    height: 90px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 25px;\n    max-width: 1100px;\n    margin: 0 auto;\n    margin-top: 50px;\n}\n\n@media (max-width: 1024px) {\n    .BC-Page__Turbo-Landing-Page section.why .list {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 1020px) {\n    .BC-Page__Turbo-Landing-Page section.steps .head {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.steps .head .left,\n    .BC-Page__Turbo-Landing-Page section.steps .head .right {\n        width: 100%;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.steps .head .right {\n        justify-content: center;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.contact {\n        min-height: 300px;\n    }\n\n}\n\n@media (max-width: 760px) {\n    .BC-Page__Turbo-Landing-Page section.why .list {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n}\n\n@media (max-width: 760px) {\n    .BC-Page__Turbo-Landing-Page .head {\n        flex-direction: column;\n        gap: 25px;\n    }\n\n    .BC-Page__Turbo-Landing-Page .head .left,\n    .BC-Page__Turbo-Landing-Page .head .right {\n        width: 100%;\n    }\n\n    .BC-Page__Turbo-Landing-Page section .head .right {\n        justify-content: center;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.steps .list {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step {\n    position: relative;\n    padding-left: 50px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step .icon {\n    position: absolute;\n    left: -40px;\n    top: -34px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content {\n    text-align: left;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-title {\n    font-weight: 400;\n    font-size: 12px;\n    margin-bottom: 10px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-label {\n    font-weight: 600;\n    font-size: 20px;\n    margin-bottom: 10px;\n}\n\n.BC-Page__Turbo-Landing-Page section.steps .list .step .step-content .step-description {\n    font-weight: 400;\n    font-size: 14px;\n    display: inline-grid;\n    line-height: 20px;\n    /* display: flex;\n    flex-wrap: wrap;\n    align-items: center; */\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .head {\n    display: flex;\n    flex-direction: column;\n    gap: 25px;\n    padding: 30px 0;\n    max-width: 768px;\n    margin: 0 auto;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .list {\n    max-width: 768px;\n    margin: 0 auto;\n}\n\n.BC-Page__Turbo-Landing-Page .Faq-list a {\n    text-decoration: none;\n}\n\n.BC-Page__Turbo-Landing-Page .Faq-list a * {\n    text-decoration: underline;\n    text-decoration-thickness: 1px;\n    text-underline-offset: 4px;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item:last-child {\n    border-bottom: 0;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .activator {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 0;\n    font-weight: 600;\n    text-align: left;\n    font-size: 20px;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .question {\n    width: calc(100% - 30px);\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .icon {\n    width: 30px;\n    text-align: right;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .activator:hover {\n    cursor: pointer;\n    color: rgba(244, 245, 246, 1);\n    opacity: 0.7;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .content {\n    padding: 0;\n    padding-bottom: 40px;\n    text-align: left;\n    padding-right: 40px;\n    line-height: 24px;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .content a {\n    color: white;\n}\n\n.BC-Page__Turbo-Landing-Page section.faq .faq-item .content>div {\n    display: flex;\n    gap: 20px;\n    flex-direction: column;\n}\n\n.BC-Page__Turbo-Landing-Page section.banner {\n    padding-bottom: 100px;\n    min-height: 300px;\n}\n\n.BC-Page__Turbo-Landing-Page section.banner .wrapper {\n    width: 100%;\n    margin: 0 auto;\n    border-radius: 16px;\n    display: flex;\n    position: relative;\n}\n\n.BC-Page__Turbo-Landing-Page section.banner .wrapper .banner-bg {\n    width: 100%;\n}\n\n.BC-Page__Turbo-Landing-Page section.banner .wrapper .content {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 20px;\n    padding-left: 40px;\n}\n\n.BC-Page__Turbo-Landing-Page section.banner .wrapper .content .title {\n    max-width: 70%;\n}\n\n.BC-Page__Turbo-Landing-Page .footer {\n    min-height: unset;\n    height: 0;\n    padding: 0;\n}\n\n.BC-Page__Turbo-Landing-Page .footer .back {\n    position: fixed;\n    right: 30px;\n    top: 30px;\n    border-radius: 50%;\n    background: linear-gradient(91.21deg, #C830E1 1.04%, #FE4A25 131.05%);\n    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.2);\n    width: 48px;\n    height: 48px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}\n\n.BC-Page__Turbo-Landing-Page .footer .back:hover {\n    animation: scale 0.5s forwards;\n}\n\n.BC-Page__Turbo-Landing-Page .footer .back.shown-bubble {\n    right: 20px;\n    bottom: 90px;\n}\n\n.BC-Page__Turbo-Landing-Page .footer .back:hover {\n    background: linear-gradient(91.21deg, #920DA7 1.04%, #CE2907 131.05%);\n    box-shadow: 0px 15.23px 91.35px 0px rgba(235, 69, 38, 0.4);\n}\n\n@media (max-width: 768px) {\n    .BC-Page__Turbo-Landing-Page section.banner {\n        padding-bottom: 100px;\n        min-height: unset;\n    }\n\n    .BC-Page__Turbo-Landing-Page section.banner .wrapper .content .action {\n        position: absolute;\n        bottom: -60px;\n        width: 100%;\n        left: 0;\n    }\n}\n\n/* END: Custom section */\n\n.darksoul-gradient-card1 {\n    display: flex;\n    height: 296px;\n    background: linear-gradient(var(--gradient-angle), #190738, #190738, #C830E1, rgb(104, 3, 255), #190738, #190738);\n    border-radius: 16px;\n    animation: rotation90 10s linear 0s infinite normal forwards;\n    backdrop-filter: blur(50px);\n}\n\n.darksoul-content-card {\n    margin: auto;\n    width: calc(100% - 2px);\n    height: calc(100% - 2px);\n    background-color: #190738;\n    border-radius: 16px;\n    transition: all 2s;\n    backdrop-filter: blur(16px);\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 20px;\n}\n\n.darksoul-content-card .item-title {\n    font-size: 20px;\n    font-weight: 600;\n}\n\n.darksoul-content-card .item-description {\n    font-size: 14px;\n    font-weight: 400;\n    padding: 0 15px;\n    text-align: center;\n    height: 50px;\n}\n\n.darksoul-content-card .item-action {\n    display: flex;\n    cursor: pointer;\n    gap: 6px;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n@media only screen and (max-width: 700px) {\n    body {\n        margin: 0;\n        width: 100%;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n        background-color: rgb(13, 13, 13);\n    }\n\n    .darksoul-gradient-card1 {\n        margin: auto;\n        width: 80%;\n        min-height: 200px;\n        margin-top: 10px;\n        margin-bottom: 10px;\n    }\n\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) {\n    max-width: 912px;\n    border-radius: 0;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) .video-modal {\n    width: 100%;\n    position: relative;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) .video-modal::before {\n    content: \"\";\n    display: block;\n    padding-top: 50%;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) .inner-content {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-size: 20px;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) .close {\n    position: absolute;\n    right: 0;\n    border-radius: 50%;\n    top: 0;\n    z-index: 99;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.video-modal) .close:hover {\n    background: rgba(0, 0, 0, 0.318);\n    cursor: pointer;\n    border: 1px solid white;\n}\n\n@media only screen and (max-width: 700px) {\n    .Polaris-Modal-Dialog__Modal:has(.video-modal) {\n        top: 50%;\n        transform: translateY(-50%);\n        background: transparent;\n    }\n}\n\n.BC-Page__Turbo-Landing-Page .navigate {\n    position: fixed;\n    top: 50%;\n    right: 16px;\n    transform: translateY(-50%);\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .item {\n    padding: 4px;\n    border-radius: 50%;\n    position: relative;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .item .circle {\n    display: block;\n    width: 10px;\n    height: 10px;\n    background: #FFFFFF33;\n    border-radius: 50%;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .item.active .circle {\n    background: #F442C8;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .item:hover {\n    cursor: pointer;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .item:hover .circle {\n    background: #A531DC;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .navigate-tooltip::after {\n    content: var(--tooltip-content);\n    position: absolute;\n    right: 20px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: #F82C9326;\n    color: #fff;\n    border-radius: 4px;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s ease;\n    width: auto;\n    white-space: nowrap;\n    padding: 4px 8px;\n}\n\n.BC-Page__Turbo-Landing-Page .navigate .navigate-tooltip:hover::after {\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
